import styled, { css } from 'styled-components';

import { layout } from '../../../package.json';

export const Root = styled.section`
  width: 100%;
  height: 45px;
  background-color: var(--navbar);
  color: var(--navbarcolor);
`

export const Container = styled.div`
  max-width: 1400px;
  height: 100%;

  padding: 0 2%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
`;

export const ContainerMenuMobile = styled.div`
  display: none;
  @media (max-width: ${layout.desktop}) {
    display: flex;
  }
`;

export const Button = styled.div`
`;

export const ContainerLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  min-width: 150px;
  align-items: center;
  gap: 10px;

  div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 5px;
  }

  @media (max-width: ${layout.desktop}) {
    display: none;
  }
`;

export const ContainerRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: ${layout.mobile}) {
    margin-right: 0px;
  } 
`;

interface ItemProps {
  marginRight?: string;
  notHover?: boolean;
}

export const Item = styled.div<ItemProps>`
  display: flex;
  justify-content: space-between;

  margin-left: 16px;

  ${props =>
    props.marginRight &&
    css`
      margin-right: ${props.marginRight}px;
    `}

  :hover {
    color: var(--navbarhover);
    cursor: pointer;
  }

  ${props =>
    props.notHover &&
    css`
      :hover {
        color: var(--white);
        cursor: unset;
      }
    `}
  svg {
    margin-right: 6px;
  }
`;

export const SelectContainer = styled.div`

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  img{
    border-radius: 2px;
    height: 22px;
    aspect-ratio: auto 33 /22; 
    width: 33px;
    position: relative;
    top: 2px;
  }
`;
export const ContainerModal = styled.div`
  .modalStyle{
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const ContainerContent = styled.div`

  overflow-y: scroll;
  width: 100%;
  max-width: 720px;
  height: 500px;
  border-radius: 10px;
  margin: 0 auto;

  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;

  >section{
    margin-top: 67px;
  }

  .containerButtons{
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    width: 100%;
    max-width: 650px;
    margin: 0 auto;
    border-bottom: 1px solid var(--star-off);
    
    >button{
      display: flex;
      color: red;
      font-weight: bold;
      font-size: 14px;
      padding: 10px 0 7px 0;
      cursor: pointer;
      svg{
          font-size: 16px;
          font-weight: bold;
      } 
    }
    .buttonClose{
      display: flex;
      font-weight: bold;

      color: var(--cardhoverbg);
      cursor: pointer;
      svg{
          font-size: 40px;
          font-weight: bold;
      } 
    }
  }

`;

export const RenderNotificationItem = styled.div`

display: flex;
flex-direction: column;
align-items: end;
border-bottom: 1px solid var(--star-off);
width: 100%;
max-width: 650px;
margin: 0 auto;
padding: 10 0px;

>button{
  display: flex;
  color: red;
  font-weight: bold;
  font-size: 14px;
  padding: 10px 0;
  cursor: pointer;
  svg{
    font-size: 16px;
    font-weight: bold;
  }
}

.notificationContent{
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  }
    img{
      width: 100px;
  }

  >div{
    cursor: pointer;
    h1{
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      
      p{
        font-size: 14px;
      }
      &:hover{
        color: var(--navbar);
      }
    }
`;

